(function () {
  var b, f;
  b = this.jQuery || window.jQuery;
  f = b(window);
  b.fn.stick_in_parent = function (d) {
    var A, w, J, n, B, K, p, q, k, E, t;
    null == d && (d = {});
    t = d.sticky_class;
    B = d.inner_scrolling;
    E = d.recalc_every;
    k = d.parent;
    q = d.offset_top;
    p = d.spacer;
    w = d.bottoming;
    null == q && (q = 0);
    null == k && (k = void 0);
    null == B && (B = !0);
    null == t && (t = "is_stuck");
    A = b(document);
    null == w && (w = !0);
    J = function (a, d, n, C, F, u, r, G) {
      var v, H, m, D, I, c, g, x, y, z, h, l;
      if (!a.data("sticky_kit")) {
        a.data("sticky_kit", !0);
        I = A.height();
        g = a.parent();
        null != k && (g = g.closest(k));
        if (!g.length) throw "failed to find stick parent";
        v = m = !1;
        (h = null != p ? p && a.closest(p) : b("<div />")) &&
          h.css("position", a.css("position"));
        x = function () {
          var c, f, e;
          if (
            !G &&
            ((I = A.height()),
            (c = parseInt(g.css("border-top-width"), 10)),
            (f = parseInt(g.css("padding-top"), 10)),
            (d = parseInt(g.css("padding-bottom"), 10)),
            (n = g.offset().top + c + f),
            (C = g.height()),
            m &&
              ((v = m = !1),
              null == p && (a.insertAfter(h), h.detach()),
              a
                .css({ position: "", top: "", width: "", bottom: "" })
                .removeClass(t),
              (e = !0)),
            (F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q),
            (u = a.outerHeight(!0)),
            (r = a.css("float")),
            h &&
              h.css({
                width: a.outerWidth(!0),
                height: u,
                display: a.css("display"),
                "vertical-align": a.css("vertical-align"),
                float: r,
              }),
            e)
          )
            return l();
        };
        x();
        if (u !== C)
          return (
            (D = void 0),
            (c = q),
            (z = E),
            (l = function () {
              var b, l, e, k;
              if (
                !G &&
                ((e = !1),
                null != z && (--z, 0 >= z && ((z = E), x(), (e = !0))),
                e || A.height() === I || x(),
                (e = f.scrollTop()),
                null != D && (l = e - D),
                (D = e),
                m
                  ? (w &&
                      ((k = e + u + c > C + n),
                      v &&
                        !k &&
                        ((v = !1),
                        a
                          .css({ position: "fixed", bottom: "", top: c })
                          .trigger("sticky_kit:unbottom"))),
                    e < F &&
                      ((m = !1),
                      (c = q),
                      null == p &&
                        (("left" !== r && "right" !== r) || a.insertAfter(h),
                        h.detach()),
                      (b = { position: "", width: "", top: "" }),
                      a.css(b).removeClass(t).trigger("sticky_kit:unstick")),
                    B &&
                      ((b = f.height()),
                      u + q > b &&
                        !v &&
                        ((c -= l),
                        (c = Math.max(b - u, c)),
                        (c = Math.min(q, c)),
                        m && a.css({ top: c + "px" }))))
                  : e > F &&
                    ((m = !0),
                    (b = { position: "fixed", top: c }),
                    (b.width =
                      "border-box" === a.css("box-sizing")
                        ? a.outerWidth() + "px"
                        : a.width() + "px"),
                    a.css(b).addClass(t),
                    null == p &&
                      (a.after(h),
                      ("left" !== r && "right" !== r) || h.append(a)),
                    a.trigger("sticky_kit:stick")),
                m && w && (null == k && (k = e + u + c > C + n), !v && k))
              )
                return (
                  (v = !0),
                  "static" === g.css("position") &&
                    g.css({ position: "relative" }),
                  a
                    .css({ position: "absolute", bottom: d, top: "auto" })
                    .trigger("sticky_kit:bottom")
                );
            }),
            (y = function () {
              x();
              return l();
            }),
            (H = function () {
              G = !0;
              f.off("touchmove", l);
              f.off("scroll", l);
              f.off("resize", y);
              b(document.body).off("sticky_kit:recalc", y);
              a.off("sticky_kit:detach", H);
              a.removeData("sticky_kit");
              a.css({ position: "", bottom: "", top: "", width: "" });
              g.position("position", "");
              if (m)
                return (
                  null == p &&
                    (("left" !== r && "right" !== r) || a.insertAfter(h),
                    h.remove()),
                  a.removeClass(t)
                );
            }),
            f.on("touchmove", l),
            f.on("scroll", l),
            f.on("resize", y),
            b(document.body).on("sticky_kit:recalc", y),
            a.on("sticky_kit:detach", H),
            setTimeout(l, 0)
          );
      }
    };
    n = 0;
    for (K = this.length; n < K; n++) (d = this[n]), J(b(d));
    return this;
  };
}.call(this));

$(document).ready(function () {
  //$(".productgrid--sidebar").stick_in_parent();

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 48) {
      $(".site-header-wrapper.site-header--sticky").addClass("after-scroll");
    } else {
      $(".site-header-wrapper.site-header--sticky").removeClass("after-scroll");
    }
  });

  $(document).on("click", ".currency-list a", function () {
    let v = $(this).data("value");
    $("#CurrencySelectorH").val(v);
    $("#CurrencySelectorHMob").val(v);
    $(this)
      .closest("form")
      .find(".hold")
      .html('<i class="fas fa-circle-notch fa-spin"></i>');
    $(this).closest("form").submit();
  });

  window.setAccordion = function () {
    var allPanels = $(
      ".product-description ul.pd-items li:not(.active) .content"
    ).hide();
    console.log(1);

    $(".product-description ul.pd-items li h5").click(function () {
      $(this).parent().addClass("active");
      $(this).parent().siblings().removeClass("active");
      $(this).parent().siblings().find(".content").slideUp();
      $(this).parent().find(".content").slideDown();
    });
  };

  setAccordion();

  $("body").on("click", ".productitem--action-qs", function () {
    var index = 0;
    var interval = setInterval(function () {
      setAccordion();
      index = index + 1;
      if (index === 10) {
        clearInterval(interval);
      }
    }, 300);
  });

  if ($("body").hasClass("template-product")) {
    console.log("yes");

    $(window).on("resize", updateSwatches);
    $(window).on("load", updateSwatches);

    $(document).on(
      "change",
      ".form-options-swatches input[name='Color']",
      updateSwatches
    );
  }

  $(document).on("click", "[data-quickshop-trigger]", function () {
    $("[data-gallery-thumbnail]").hide();
    setTimeout(function () {
      updateSwatches();
    }, 250);
  });

  if ($("body").hasClass("template-collection") && window.innerWidth > 760) {
    $(document).on(
      "change",
      ".modal .form-options-swatches input[name='Color']",
      updateSwatches
    );
  }

  function updateSwatches() {
    console.log("ok");
    if ($("body").hasClass("modal-visible")) {
      var v = $(
        ".modal--quickshop-full .form-options-swatches input[name='Color']:checked"
      ).attr("value");
      var title = $(".modal--quickshop-full .product-title").text();
    } else {
      var v = $(".form-options-swatches input[name='Color']:checked").attr(
        "value"
      );
      var title = $(".product-title").text();
    }
    var str = title.trim() + " - " + v.trim() + " thumbnail";

    $("[data-gallery-thumbnail]").hide();
    $("[data-gallery-thumbnail][aria-label='" + str + "']").fadeIn();

    $(".template-product .product-gallery--navigation").css({
      width: "4.25rem !important",
      "max-width": "4.25rem !important",
    });
  }

  /*** cookies ***/

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }
  


  var $popupContent = $("#popup .fx");

  var newsletterCookie = getCookie("newsletterPopup");
  if (!newsletterCookie && $('[data-popup-display=true]').length) {
    setTimeout(function () {
      $.featherlight('<div id="newsletter-popup-1"></div>', {
        beforeClose: function () {
          $popupContent.appendTo("#popup");
          $popupContent.removeClass("featherlight-inner");
        },
      });
      $popupContent.addClass("featherlight-inner");
      $popupContent.appendTo("#newsletter-popup-1");
    }, 2500);
    setCookie("newsletterPopup", true, 7);
  }

  $("[data-click-newsletter]").click(function () {
    $.featherlight('<div id="newsletter-popup-1"></div>', {
      beforeClose: function () {
        $popupContent.appendTo("#popup");
        $popupContent.removeClass("featherlight-inner");
      },
    });
    $popupContent.addClass("featherlight-inner");
    $popupContent.appendTo("#newsletter-popup-1");
  });

  var cartInterval = setInterval(function () {
    console.log("Looking for Shopify...");
    if (!!Shopify) {
      console.log("Shopify Loaded");
      clearInterval(cartInterval);
      upSell();
    }
  }, 200);

  $(".bundle-image-list img").on("click", function () {
    $(".bundle-image-list img").removeClass("active");
    $(this).addClass("active");
    $(".bundle-image .main-image").attr("src", $(this).attr("src"));
  });

  $("body").on("click", ".size-guide-toggle", function (e) {
    e.preventDefault();
    $("#size-guide-modal").fadeIn();
  });

  $("#size-guide-modal .featherlight-close, #size-guide-modal").click(
    function () {
      $("#size-guide-modal").fadeOut();
    }
  );

  // $('.cart-continue-back').click(function (e) {
  //   e.preventDefault();
  //   history.back();
  // });

  $(".size-guide").click(function (e) {
    e.stopPropagation();
  });

  $("#size-guide-modal .size-toggle a").on("click", function () {
    $("#size-guide-modal .size-toggle a").removeClass("active");
    $(this).addClass("active");
    var index = $("#size-guide-modal .size-toggle a").index(this);
    $("#size-guide-modal .size-guide-table").hide();
    $("#size-guide-modal .size-guide-table").eq(index).show();
    
  });

  $("#size-guide-no-modal .size-toggle a").on("click", function () {
    $("#size-guide-no-modal .size-toggle a").removeClass("active");
    $(this).addClass("active");
    var index = $("#size-guide-no-modal .size-toggle a").index(this);
    $("#size-guide-no-modal .size-table-wrapper").hide();
    $("#size-guide-no-modal .size-table-wrapper").eq(index).show();
  });
  
  $(".size-guide-button").on("click", function () {
    $('.hidden-image').hide();
    var index = $(this).index();
    $(".size-guide-button").removeClass("active");
    $(this).addClass("active");
    $(".button-content-wrapper > div").hide();
    $(".button-content-wrapper > div").eq(index).show();
  });
  
  $(".size-table-wrapper td").mouseenter(function () {
    if (!!$(this).attr('colspan')) return;
    var index = $(this).index();
    $(this).css({"background": "#000", color: "#fff"});
    $(this).parent().find("td").eq(0).css({"background": "#000", color: "#fff"});
    $(this)
    .closest("table")
    .find("th")
    .eq(index)
    .css({"background": "#000", color: "#fff"});
  });

  $(".size-table-wrapper td").mouseleave(function () {
        if (!!$(this).attr('colspan')) return;
    var index = $(this).index();
    $(this).removeAttr("style");
    $(this).parent().find("td").eq(0).removeAttr("style");
    $(this)
    .closest("table")
    .find("th")
    .eq(index)
    .removeAttr("style");
  });

  $(".sezzle-button-text").on("click", () => {
    $(".sezzle-modal").css("display", "flex");
  });

  $(".sezzle-modal").on("click", () => {
    $(".sezzle-modal").css("display", "none");
  });
  setInterval(() => {
    if ($(".bar-message1").css("display") != "none") {
      $(".bar-message1").fadeOut(400, function () {
        $(".bar-message2").fadeIn();
      });
    } else {
      $(".bar-message2").fadeOut(400, function () {
        $(".bar-message1").fadeIn();
      });
    }
  }, 5000);

  $(".bundle-grid .money." + Shopify.currency.active).show();

  function upSell() {
    var cartUpsell = document.getElementById("upsell");

    if (cartUpsell) {
      var freeShipping = Shopify.currency.rate * 20000;

      var difference = freeShipping - window._carttotal;
      var diffInMoney = Shopify.formatMoney(
        difference,
        window._moneywithcurrencyformat
      );

      if (difference > 0) {
        document.getElementById(
          "upsell"
        ).innerHTML = `You are ${diffInMoney} away from free shipping.`;
        console.log(diffInMoney);
      }
    }
  }


  let $itemAdded = false;
  let $isCart = false;
  let $itemChanged = false;
  let $itemUpdated = false;
  let $itemChangedRecently = false;
  let $itemShowNotification = false;
  let $tryingRemoveProduct = false;
  let $itemChangedQuantity = false;

  
  // BUY MORE, GET MORE START
  /*$.ajaxSetup({
      beforeSend: function(xhr, settings){
          if(settings.url == '/cart/add.js'){
              $itemAdded = true;
              //if(settings.data.includes('SaleCollection0320')){
                  $itemShowNotification = true;
              //}
          }
          if(window.location.href == 'https://michiny.com/cart' && settings.url == '/cart/change.js'){
              $itemChanged = true;
          }
          if($itemAdded){
              if(settings.url == '/cart.js'){
                  $isCart = true;
              }
          }
      },

      complete: function(result, status){

          if($itemChanged == true){
            
            $itemAdded = false;
            $itemChanged = false;
            $itemUpdated = false;
            $isCart = false;

            addGiftCard(result.responseJSON, $itemShowNotification)

          }

      },
      
      success: function (result, status, xhr){

          if($isCart == true || $itemChanged == true){
            
            $itemAdded = false;
            $itemChanged = false;
            $itemUpdated = false;
            $isCart = false;

            addGiftCard(result, $itemShowNotification)

          }
      }
      
  });*/
  // BUY MORE, GET MORE END
  

  /* Add Item to Cart */

  var addItemToCart = function(itemID, cart, showNotification) {
    
    var needs_item = false,
        productArray = [],
        msg = null;

    // already there?
    cart.items.forEach(function(citem){
        productArray.push(citem.variant_id);
    });

    if(productArray.includes(itemID) && productArray.length == 1){

      // the product is there alone but we did not try to remove it
      sessionStorage.setItem('protectFromRemove', true);
      setTimeout(() => {
        sessionStorage.setItem('protectFromRemove', false);
      }, 500);

      var paramsDelete = {
        type: 'POST',
        url: '/cart/change.js',
        data: `quantity=0&id=${itemID}`
      };
      jQuery.ajax(paramsDelete);
    }

    if(productArray.includes(itemID) || productArray.length == 0){
        needs_item = false;
    } else {
        needs_item = true;
    }

    msg = `<b>Free FITISH Gift added to your bag.</b>`;

    if(window.location.href == 'https://michiny.com/cart'){
        $(".cartOverlay").css('display','flex');
        setTimeout(function(){
            window.location.reload();
        }, 1000);
    }

    //--- add the necessary item
    if(needs_item == true)
    {
          var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: `quantity=1&id=${itemID}`
          };

          setTimeout(function(){
              jQuery.ajax(params);
              if(window.location.href == 'https://michiny.com/cart'){
                  $(".cartOverlay").css('display','flex');
                  setTimeout(function(){
                      window.location.reload();
                  }, 1000);
              } else {
                  if(showNotification == true){
                    $.notiny({ text: msg, position: 'fluid-top' });
                  }
              }
          }, 500);
      }

  };

  /* reload cart */

  if(window.location.href.includes('/cart'))
  {
      $("[data-quantity-select]").on('change', function(){
          $(".cartOverlay").css('display','flex');
          setTimeout(function(){
              window.location.reload();
          }, 1000);
      })

      $("[data-cartitem-remove]").on('click', function(){
          $(".cartOverlay").css('display','flex');
          setTimeout(function(){
              window.location.reload();
          }, 1000);
      })
  }

  /** Gift Card **/

  var addGiftCard = function(cart, showNotification) {
    
    var $card = null,
        $card_50 = 45627774088,
        $card_100 = 45627774152,
        $card_200 = 45627898632,
        $card_300 = 31278770683956;
    
    var needs_card = false,
        how_much_for_card = false,
        msg = null;

    var currency = cart.currency,
        currencySymbol = currency == 'EUR' ? '€' : '$',
        totalPrice = cart.total_price;

    //--- FIRST CLEAR THE CART FROM CARDS

    cart.items.forEach(function(citem)
    {  
        if(citem.variant_id == $card_50 || citem.variant_id == $card_100 || citem.variant_id == $card_200 || citem.variant_id == $card_300){    
            var paramsDelete = {
                type: 'POST',
                url: '/cart/change.js',
                data: `quantity=0&id=${citem.variant_id}`
            }
            jQuery.ajax(paramsDelete);
        }
    });

    // --- MUST BE IN TAGS --- //

    totalPrice = 0; // reset price
    cart.items.forEach(function(citem)
    {  
        //if(citem.properties.tags == 'SaleCollection0320'){
            //citem.final_price
            //citem.discounted_price
            //citem.final_line_price
            totalPrice += citem.final_line_price;
        //}
    });
   
    // --- end --- //
      
    if(totalPrice < Currency.convert(25000, 'USD', currency)){
        msg = `<b>Add ${currencySymbol}${Currency.convert(250, 'USD', currency).toFixed(2)} ${currency} sale items to your bag to receive a $50 USD e-Gift Card.</b>`;
        how_much_for_card = true;
    }
    if(totalPrice >= Currency.convert(25000, 'USD', currency)){
        $card = $card_50; 
        msg = `<b>$50 USD e-Gift Card added to bag</b> <br /> <span style="font-size:0.75em">Add ${currencySymbol}${((50000 - totalPrice)/100).toFixed(2)} ${currency} more sale items to your bag to receive a $100 USD e-Gift Card.</span>`;
        needs_card = true;
    }
    if(totalPrice >= Currency.convert(50000, 'USD', currency)){
        $card = $card_100;
        msg = `<b>$100 USD e-Gift Card added to bag</b> <br /> <span style="font-size:0.75em">Add ${currencySymbol}${((75000 - totalPrice)/100).toFixed(2)} ${currency} more sale items to your bag to receive a $200 USD e-Gift Card.</span>`;
        needs_card = true;
    }
    if(totalPrice >= Currency.convert(75000, 'USD', currency)){
        $card = $card_200; 
        msg = `<b>$200 USD e-Gift Card added to bag</b> <br /> <span style="font-size:0.75em">Add ${currencySymbol}${((100000 - totalPrice)/100).toFixed(2)} ${currency} more sale items to your bag to receive a $300 USD e-Gift Card.</span>`;
        needs_card = true;
    }
    if(totalPrice >= Currency.convert(100000, 'USD', currency)){
        $card = $card_300; 
        msg = `<b>$300 USD e-Gift Card added to bag</b>`;
        needs_card = true;
    }

    if(window.location.href == 'https://michiny.com/cart'){
        $(".cartOverlay").css('display','flex');
        setTimeout(function(){
            window.location.reload();
        }, 1000);
    }

    if(totalPrice == 0) return;
    
    //--- add the necessary one card
    if(needs_card == true){
          var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: `quantity=1&id=${$card}`
          }
          setTimeout(function(){
              jQuery.ajax(params);
              if(window.location.href == 'https://michiny.com/cart'){
                  $(".cartOverlay").css('display','flex');
                  setTimeout(function(){
                      window.location.reload();
                  }, 1000);
              } else {
                  if(showNotification == true){
                    $.notiny({ text: msg, position: 'fluid-top' });
                  }
              }
          }, 500);
      }    

      //--- how much needs?
      if(showNotification == true){
        if(how_much_for_card == true && window.location.href != 'https://michiny.com/cart'){
            $.notiny({ text: msg, position: 'fluid-top' });
        }
      }
  };

  $(document).on('click', 'h3.productgrid--sidebar-title--small', function(){
      $(this).parent('ul.filter-group').toggleClass('open');
  });

  let sizeOrder = ['XX-Small','X-Small','Small','Medium','Large','X-Large','Xlarge'];

  document.querySelectorAll('.ul-filter-type--size li').forEach(item => {
      let filterText = item.querySelector('.filter-text').innerText.trim();
      let position = sizeOrder.indexOf(filterText);
      item.setAttribute('data-position', position);
  });

  $(".ul-filter-type--size li").sort(sort_li).appendTo('.ul-filter-type--size');
  function sort_li(a, b) {
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
  }

});